import { BoardType } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useBoardTypeLocalPersistence(): useBoardTypeLocalPersistenceReturn {
  return useLazyContext(BoardTypeLocalPersistenceContext);
}

export type useBoardTypeLocalPersistenceReturn = {
  getBoardType: () => Promise<BoardType | undefined>;
  setBoardType: (boardType: BoardType) => Promise<void>;
};

export const BoardTypeLocalPersistenceContext =
  createContext<LazyValue<useBoardTypeLocalPersistenceReturn>>(undefined);
